"use client";
import React, { useEffect, useState } from "react";
import { ProfileOverview } from "./ProfileOverview";
import { UpdateProfile } from "./UpdateProfile";
import { useAppKitAccount } from "@reown/appkit/react"; // ✅ Import hook

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const { isConnected, address } = useAppKitAccount(); // ✅ Wallet connection

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }

    const syncUser = () => {
      const updatedUser = localStorage.getItem("user");
      if (updatedUser) {
        setUser(JSON.parse(updatedUser));
      } else {
        setUser(null);
      }
    };

    window.addEventListener("storage", syncUser);
    return () => window.removeEventListener("storage", syncUser);
  }, []);

  // ✅ Show message if either user is not logged in or wallet not connected
if (!user && (!isConnected || !address)) {
  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="bg-[#2a223a] border border-white/10 text-white px-8 py-6 rounded-lg shadow-md text-center max-w-md">
        <h2 className="text-xl font-semibold mb-2 text-white">Access Restricted</h2>
        <p className="text-base text-[#bebebe]">
          Please log in and connect your wallet to view your profile.
        </p>
      </div>
    </div>
  );
}


  // ✅ Show components only when both conditions are met
  return (
    <div className="relative w-full overflow-hidden bg-transparent">
      <ProfileOverview />
      <UpdateProfile />
    </div>
  );
};

export default ProfilePage;
